// Matches /competition/:slug but not the bare /competition/preview path
const COMPETITION_SLUG_PATH = /^\/competition\/(?!preview(?:\/|$))[^/]+\/?$/;
// Matches /competition/preview/:id
const COMPETITION_PREVIEW_PATH = /^\/competition\/preview\/[^/]+\/?$/;

export const isCompetitionSlugPath = (pathname = '') => COMPETITION_SLUG_PATH.test(pathname);

export const isCompetitionPreviewPath = (pathname = '') => COMPETITION_PREVIEW_PATH.test(pathname);

// Any competition page, live or preview - used to opt into the clear nav bar layout
export const isCompetitionPagePath = (pathname = '') =>
  isCompetitionSlugPath(pathname) || isCompetitionPreviewPath(pathname);

export default {
  isCompetitionSlugPath,
  isCompetitionPreviewPath,
  isCompetitionPagePath,
};
